<template>
  <v-dialog :value="value" @input='$listeners.input' :max-width="360">
     <v-card flat class='d-flex flex-column fill-height'> 
      <v-card-title>
        {{$t('share.title')}}
        <v-spacer/>
        <close-button @close="$listeners.input"/>
      </v-card-title>
      <v-card-text>
        <v-text-field :value="shortUrl" :error="error" :loading="loading" readonly :hide-details="true" dense outlined>
          <template v-slot:append>
            <clipboard :disabled="loading || error" v-if="value" icon small :text="shortUrl"/>
          </template>
        </v-text-field>
      </v-card-text>
     </v-card>
  </v-dialog>
</template>

<script>
import { defineComponent, watch, ref, computed } from 'vue';
import { getCurrentInstance } from 'vue'
import { requestShortUrl } from '../utils/client';
import Clipboard from './Clipboard.vue';
import CloseButton from './CloseButton.vue';

export default defineComponent({
  components: { 
    CloseButton,
    Clipboard,
  },
  props: {
    value: {
      type: Boolean,
      required: true
    }
  },
  setup(props, context){
    const root = getCurrentInstance();
    const loading = ref(true);
    const error = ref(false);
    const shortURI = ref('');

    watch(()=>props.value, ()=>{
      if (props.value){
        init();
        requestShortUrl()
        .then(short => {
          shortURI.value = short;
        })
        .catch(()=>{
          error.value = true;
        })
        .finally(()=>{
          loading.value = false;
        })
      }
    })

    const init = ()=>{
      loading.value = true;
      error.value = false;
    }

    const shortUrl = computed(()=>{
      if (loading.value){
        return '...'
      }
      if (error.value){
        return root.proxy.$t('something_went_wrong');
      }
      return `${process.env.VUE_APP_IPAWORKS_URL}/${shortURI.value}`
    })

    return {
      shortUrl,
      error,
      loading
    }
  }
})
</script>
